import { useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import type { CommunicationSubTab } from "./communication/communicationSubTab";
import type { EventTab } from "./EventTabs";

export type EventSubTab = CommunicationSubTab;

export const useGoToEventTab = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  return useCallback(
    (tab: EventTab, subTab?: EventSubTab) => {
      const next = new URLSearchParams(searchParams);
      next.set("tab", tab);
      if (subTab) next.set("sub", subTab);
      else next.delete("sub");
      setSearchParams(next, { replace: true });
    },
    [searchParams, setSearchParams],
  );
};
